import { ChangeDetectorRef, Component, OnInit, Type } from "@angular/core";
import { ICommand } from "../../../modules/records/commands/i-command";
import { IApiService } from "../../../modules/records/models/api/i-api-service";
import { ActionCol } from "../../table-col-configs/action-col";

@Component({
  selector: "app-action-buttons",
  templateUrl: "./action-buttons.component.html",
  styleUrls: ["./action-buttons.component.scss"],
})
export class ActionButtonsComponent<T extends object> implements OnInit {
  data: string = "";
  commands: ICommand<T, IApiService<T>>[] = [];
  el!: T;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { }

  setComponentData(
    el: T,
    colConfig: ActionCol<T, Type<ActionButtonsComponent<T>>, IApiService<T>>
  ) {
    this.data = colConfig.getElementData(el);
    this.commands = colConfig.commands;
    this.el = el;
  }

  onClick(index: number) {
    this.commands[index].execute(this.el);

    // Start polling for loading state changes to force UI refresh
    const checkInterval = setInterval(() => {
      const isStillLoading = this.isCommandLoading(this.commands[index], this.el);
      this.cdr.markForCheck();

      // Stop polling when loading is complete
      if (!isStillLoading) {
        clearInterval(checkInterval);
        this.cdr.markForCheck(); // Final check to ensure UI updates
      }
    }, 100); // Check every 100ms

    // Safety timeout to stop polling after 30 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 30000);
  }

  isCommandLoading(command: ICommand<T, IApiService<T>>, el: T): boolean {
    // Check if the command has isLoadingForElement method (for row-specific loading)
    if ('isLoadingForElement' in command && typeof (command as any).isLoadingForElement === 'function') {
      return (command as any).isLoadingForElement(el);
    }
    // Fallback to global isLoading property
    return (command as any).isLoading || false;
  }

  showLabelWhenLoading(command: ICommand<T, IApiService<T>>, el: T){
    // Check if the command has showLabelForElement method (for row-specific loading)
    let showLabelForElement = false;
    if ('showLabelForElement' in command && typeof (command as any).showLabelForElement === 'function') {
      showLabelForElement = (command as any).showLabelForElement(el);
    }

    return showLabelForElement || !this.isCommandLoading(command, el) || (this.isCommandLoading(command, el) && command.icon);
  }

  truncateText(text: string): string {
    if (!text) return '';
    const maxLength = 20;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }
}
